<template>
  <div style="margin: 10px 70px">
    <el-form :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label="设备编号" label-width="90px" prop="device_id">
        <el-autocomplete style="width: 100%" class="inline-input" v-model="addEditForm.device_id"
                         :fetch-suggestions="querySearch" placeholder="请输入设备编号" :trigger-on-focus="false" @input="handleInput" @select="handleSelect">
        </el-autocomplete>
      </el-form-item>
      <!--添加网关-->
      <el-form-item v-if="isShow && isHome" :label="isLabel" label-width="90px" prop="hid">
        <div v-if="addDeviceRow.row === '' && !addDeviceRow.isGateway">
          <div>
            <el-row>
              <el-col :span="24">
                <el-cascader v-fixZoom
                  style="width: 100%"
                  :options="orgOptions"
                  v-model="oid"
                  :filterable="true"
                  placeholder="请选择组织"
                  :props="{ checkStrictly: true, value: 'id', label: 'name', children: 'child', emitPath: false}"
                  ref="orgOptions"
                  @change="selectOrgID">
                </el-cascader>
              </el-col>
            </el-row>
          </div>
          <div>
            <el-row>
              <el-col :span="12">
                <el-select v-fixZoom v-model="cid" filterable  :placeholder="isCenterName" style="width: 100%" @change="selectCommunityID">
                  <el-option v-for="item in orgcommunitys" :key="item.value" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-col>
              <el-col :span="12">
                <el-select v-fixZoom filterable style="width: 100%" v-model="addEditForm.hid" :placeholder="isRightName" @change="selectHome">
                  <el-option v-for="item in selectorghomes" :key="item.id" :label="item.address" :value="item.id">
                    <span style="">{{ item.address }}</span>&nbsp;
                    <span style="color: #8492a6; font-size: 12px">{{ item.telephone }}</span>
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
          </div>
        </div>
        <div v-else>{{homeAddress}}</div>
      </el-form-item>
      <el-form-item v-if="isShow && isHome" label="安装位置" label-width="90px">
        <el-input style="width: 100%" v-model="addEditForm.installlocation" autocomplete="off"></el-input>
      </el-form-item>
      <!--添加手表/随身通-->
      <el-form-item v-if="isShow && !isHome" label="所属人员" label-width="90px" prop="pid">
        <div v-if="addDeviceRow.row === ''">
          <div>
            <el-row>
              <el-col :span="12">
                <el-cascader v-fixZoom
                  style="width: 100%"
                  :options="orgOptions"
                  v-model="oid"
                  :filterable="true"
                  placeholder="请选择组织"
                  :props="{ checkStrictly: true, value: 'id', label: 'name', children: 'child', emitPath: false}"
                  ref="orgOptions"
                  @change="selectOrgID">
                </el-cascader>
              </el-col>
              <el-col :span="12">
                <el-select v-fixZoom v-model="cid" filterable  :placeholder="isCenterName" style="width: 100%" @change="selectCommunityID">
                  <el-option v-for="item in orgcommunitys" :key="item.value" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
          </div>
          <div>
            <el-row>
              <el-col :span="12">
                <el-select v-fixZoom style="width: 100%" v-model="hid" placeholder="请选择已有家庭/机构" @change="selectHomeID">
                  <el-option v-for="item in selectorghomes" :key="item.id" :label="item.address" :value="item.id">
                    <span style="">{{ item.address }}</span>&nbsp;
                    <span style="color: #8492a6; font-size: 12px">{{ item.telephone }}</span>
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="12">
                <el-select v-fixZoom style="width: 100%" filterable v-model="addEditForm.pid" placeholder="请选择所属人员" @change="selectPerson">
                  <el-option v-for="item in selectoldpersons" :key="item.index" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-col>
            </el-row>
          </div>
        </div>
        <div v-else>{{addDeviceRow.row.name}}</div>
      </el-form-item>
      <el-form-item label="设备号码" label-width="90px" prop="phone">
        <el-input style="width: 100%" placeholder="请输入设备号码" v-model="addEditForm.phone" :disabled="isEdit" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div>
      <el-row style="margin: 0 100px">
        <el-col :span="12">
          <div class="cancel-btn" @click="closeAdd()"><span>取消</span></div>
        </el-col>
        <el-col :span="12">
          <div class="send-btn" @click="submitAddDevice('addEditForm')"><span>确定</span></div>
        </el-col>
      </el-row>
    </div>
    <div style="height: 20px"></div>
  </div>
</template>

<script>
import {binddevicetohome, binddevicetoperson, searchunbinddevice} from '../../../api/device'
import {querycommunitybyorgids} from '../../../api/organizer'
import {queryhomebycids} from '../../../api/relation'
import {queryoldpersonbyhids} from '../../../api/handlealarm'

export default {
  name: 'deviceAdd1',
  model: {
    prop: 'addShow',
    event: 'change'
  },
  props: {
    addDeviceRow: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      addEditForm: {
        deviceid: '',
        did: '',
        phone: '',
        hid: '',
        installlocation: '',
        pid: '',
        device_id: ''
      },
      addEditRules: {
        device_id: [
          { required: true, message: '请输入设备编号', trigger: 'change' }
        ],
        phone: [
          { required: true, message: '请输入设备号码', trigger: 'blur' }
        ],
        hid: [
          { required: true, message: '', trigger: 'change' }
        ],
        pid: [
          { required: true, message: '请选择所属人员', trigger: 'change' }
        ]
      },
      isLabel: '所属家庭/机构',
      isCenterName: '请选择小区',
      isRightName: '请选择已有家庭',
      isEdit: false,
      isShow: false, // 是否显示添加网关还是手表的列
      isHome: true, // true 添加网关 false 添加手表
      moduletag: '',
      orgOptions: [],
      orgcommunitys: [],
      selectorghomes: [],
      selectoldpersons: [],
      homeAddress: '',
      oid: '',
      cid: '',
      hid: ''
    }
  },
  created () {
    this.moduletag = this.$store.state.user.moduletag
    this.getModuleTag()
    this.getOrgOptions()
    /* 弃 */
  },
  methods: {
    getModuleTag () {
      if (this.addDeviceRow.home) { // 网关（家添加）
        this.addEditForm.hid = this.addDeviceRow.home.id
        this.addEditForm.phone = this.addDeviceRow.home.telephone
        this.homeAddress = this.addDeviceRow.home.telephone + ' -- ' + this.addDeviceRow.home.address
      }
      if (this.addDeviceRow.row !== '') { // 快捷弹窗人添加设备addDeviceRow.row人信息
        // console.log('快捷弹窗人添加设备')
        this.addEditForm.pid = this.addDeviceRow.row.id
        this.addEditForm.hid = this.addDeviceRow.row.homeid
        // this.addEditForm.phone = this.addDeviceRow.row.phone
        this.addEditForm.phone = ''
      }
      if (this.moduletag === 1) {
        this.isRightName = '请选择已有家庭'
        this.isCenterName = '请选择小区'
        this.isLabel = '所属家庭'
        this.addEditRules.hid[0].message = '请选择所属家庭'
      } else if (this.moduletag === 2) {
        this.isRightName = '请选择已有房间'
        this.isCenterName = '请选择机构'
        this.isLabel = '所属房间'
        this.addEditRules.hid[0].message = '请选择所属房间'
      } else { // 0
        this.isRightName = '请选择已有家庭/房间'
        this.isCenterName = '请选择小区/机构'
        this.isLabel = '家庭/房间'
        this.addEditRules.hid[0].message = '请选择所属家庭/房间'
      }
    },
    getOrgOptions () {
      let lastLevel = 100
      const arr = this.addDeviceRow.orgTree
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].level < lastLevel) {
          lastLevel = arr[i].level
        }
      }
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].level === lastLevel) {
          this.orgOptions.push(arr[i])
        }
      }
      for (let i = 0; i < this.orgOptions.length; i++) {
        const child = this.arrayToNode(arr, this.orgOptions[i].id)
        if (child.length !== 0) {
          this.orgOptions[i].child = child
        }
      }
    },
    // 递归
    arrayToNode (nodesArray, pid) {
      const vm = this
      return nodesArray.filter(value => {
        if (value.orgpid === pid) {
          const arrayToNode = vm.arrayToNode(nodesArray, value.id)
          if (arrayToNode.length > 0) {
            value.child = arrayToNode
          }
          return value
        }
      })
    },
    handleInput (value) {
      if (value.length !== '15') {
        this.isShow = false
        this.addEditForm.did = ''
        this.addEditForm.deviceid = ''
        this.addEditForm.phone = ''
        this.addEditForm.hid = ''
        this.addEditForm.pid = ''
        this.addEditForm.installlocation = ''
        this.oid = ''
        this.cid = ''
        this.hid = ''
        this.orgcommunitys = []
        this.selectorghomes = []
        this.selectoldpersons = []
        this.homeAddress = ''
      }
    },
    handleSelect (item) {
      // console.log('item', item)
      this.addEditForm.did = item.id
      this.addEditForm.deviceid = item.deviceid
      this.addEditForm.phone = item.simcardno
      this.isHome = !(item.dtype === 300 || item.dtype === 901 || item.dtype === 350)
      this.isEdit = !(item.simcardno === '' || item.simcardno.length !== 11)
      this.isShow = true
    },
    querySearch (queryString, cb) {
      if (queryString.length < 4) {
        let arr = []
        cb(arr)
        return
      }
      searchunbinddevice({lessdeviceid: queryString}).then(res => {
        let re = []
        for (let i = 0; i < res.data.devices.length; i++) {
          if (this.addDeviceRow.isGateway) {
            if (res.data.devices[i].devicetype === 700 || res.data.devices[i].devicetype === 504) {
              re.push({
                value: res.data.devices[i].deviceid + '(' + this.getDtpye(res.data.devices[i].devicetype) + ')',
                deviceid: res.data.devices[i].deviceid,
                dtype: res.data.devices[i].devicetype,
                id: res.data.devices[i].id,
                simcardno: res.data.devices[i].simcardno
              })
            }
          } else {
            re.push({
              value: res.data.devices[i].deviceid + '(' + this.getDtpye(res.data.devices[i].devicetype) + ')',
              deviceid: res.data.devices[i].deviceid,
              dtype: res.data.devices[i].devicetype,
              id: res.data.devices[i].id,
              simcardno: res.data.devices[i].simcardno
            })
          }
        }
        cb(re)
        // console.log('re', re)
      }).catch(() => {
        let arr = []
        cb(arr)
      })
    },
    getDtpye (type) {
      return this.commonType.getDeviceType(type)
    },
    // change事件
    selectOrgID (id) {
      this.cid = ''
      let data = {
        orgids: [id]
      }
      querycommunitybyorgids(data).then(res => {
        this.orgcommunitys = res.data.communitys
      }).catch(() => {})
    },
    selectCommunityID (id) {
      this.hid = ''
      this.addEditForm.hid = ''
      this.addEditForm.pid = ''
      this.homeAddress = ''
      for (let i = 0; i < this.orgcommunitys.length; i++) {
        if (id === this.orgcommunitys[i].id) {
          if (this.orgcommunitys[i].zone_type === 1) {
            this.isRightName = '请选择已有家庭'
          } else if (this.orgcommunitys[i].zone_type === 2) {
            this.isRightName = '请选择已有房间'
          }
        }
      }
      let data = {
        cids: [id]
      }
      queryhomebycids(data).then(res => {
        this.selectorghomes = res.data.homes
      }).catch(() => {})
    },
    selectHome (id) { // 网关选家
      for (let i = 0; i < this.selectorghomes.length; i++) {
        if (id === this.selectorghomes[i].id) {
          if (!this.isEdit) {
            this.addEditForm.phone = this.selectorghomes[i].telephone
          }
          this.homeAddress = this.selectorghomes[i].telephone + ' -- ' + this.selectorghomes[i].address
        }
      }
      // console.log(this.homeAddress)
    },
    selectHomeID (id) {
      this.pid = ''
      this.addEditForm.pid = ''
      this.addEditForm.phone = ''
      this.isEdit = false
      let data = {
        hids: [id]
      }
      queryoldpersonbyhids(data).then(res => {
        this.selectoldpersons = res.data.persons
      }).catch(() => {})
    },
    selectPerson (id) {
      for (let i = 0; i < this.selectoldpersons.length; i++) {
        if (id === this.selectoldpersons[i].id) {
          if (!this.isEdit) {
            this.addEditForm.phone = this.selectoldpersons[i].phone
          }
        }
      }
    },
    closeAdd () {
      this.$emit('change', false)
    },
    submitAddDevice (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.isHome) {
            // 网关
            let data = {
              did: this.addEditForm.did,
              hid: this.addEditForm.hid,
              deviceid: this.addEditForm.deviceid,
              phone: this.addEditForm.phone,
              installlocation: this.addEditForm.installlocation
            }
            if (data.deviceid === '') {
              this.$message.error('暂无录入此设备')
              return
            }
            binddevicetohome(data).then(res => {
              this.$notify({
                title: '成功',
                message: '成功绑定设备',
                type: 'success',
                duration: 2000
              })
              this.golobleObject.updateTableDevice()
              this.$emit('change', false)
            }).catch(() => {
              this.$notify.error({
                title: '失败',
                message: '绑定设备失败'
              })
            })
          } else {
            // 手表
            let data = {
              did: this.addEditForm.did,
              pid: this.addEditForm.pid,
              deviceid: this.addEditForm.deviceid,
              phone: this.addEditForm.phone
            }
            if (data.deviceid === '') {
              this.$message.error('暂无录入此设备')
              return
            }
            binddevicetoperson(data).then(res => {
              this.$notify({
                title: '成功',
                message: '成功绑定设备',
                type: 'success',
                duration: 2000
              })
              if (this.addDeviceRow.isAddPerson) {
                let obj = {
                  type: 'addOldPerson'
                }
                this.$emit('getFatherDevice', obj)
              } else {
                this.golobleObject.updateTableDevice()
                this.$emit('change', false)
              }
            }).catch(() => {
              this.$notify.error({
                title: '失败',
                message: '绑定设备失败'
              })
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/childComponents/deviceAdd1.vue